import { makeStorageHook } from "./makeStorageHook";

export const useSessionStorage = makeStorageHook(window.sessionStorage);
